// ----------featured start------------


if ($(Window).width() > 768) {
  $(".featured__items").slick({
    infinite: true,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 5000,
    cssEase: "linear",
    variableWidth: true,
    arrows: false,
    pauseOnHover: false,
    responsive: [{
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
      },
    }, ],
  });
}




// ----------featured end------------







// -------------------sellers start------------------


if ($(Window).width() < 768) {
  $('.sellers__items').slick({
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    responsive: [{
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }, ]
  });
}


  // Click event for left arrow of parent slider
  $('.sellers__left-arrow').click(function () {
    // Directly move the parent slider to the previous slide
    $('.sellers__items').slick('slickPrev');
  });

  // Click event for right arrow of parent slider
  $('.sellers__right-arrow').click(function () {
    // Directly move the parent slider to the next slide
    $('.sellers__items').slick('slickNext');
  });




$('.sellers__items').on('afterChange', function (event, slick, currentSlide) {
  if (currentSlide === 0) {
    $('.sellers__left-arrow').addClass('hidden');
  } else {
    $('.sellers__left-arrow').removeClass('hidden');
  }
  if (currentSlide === slick.slideCount - 1) {
    $('.sellers__right-arrow').addClass('hidden');
  } else {
    $('.sellers__right-arrow').removeClass('hidden');
  }
  // if ($(window).width() > 768) {
  //   if (currentSlide === slick.slideCount - 1) {
  //     $('.sellers__right-arrow').addClass('hidden');
  //   } else {
  //     $('.sellers__right-arrow').removeClass('hidden');
  //   }
  //   // console.log(currentSlide, "-", slick.slideCount - 3);
  // } else {
  //   if (currentSlide === slick.slideCount - 1) {
  //     $('.sellers__right-arrow').addClass('hidden');
  //   } else {
  //     $('.sellers__right-arrow').removeClass('hidden');
  //   }
  // }
});


// -------------------sellers thumbnail slider------------------
document.addEventListener('DOMContentLoaded', function () {
  $('.sellers__card-slider').each(function () {
    const $slider = $(this);

    if (!$slider.hasClass('slick-initialized')) {
      $slider.slick({
        dots: false,
        arrows: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        swipe: false,
        draggable: false,
        waitForAnimate: false,
        pauseOnHover: true,
        pauseOnFocus: true,
        prevArrow: '<button class="sellers-slick-prev" aria-label="Previous"><svg width="24" height="24" viewBox="0 0 24 24"><path d="M15 6l-6 6 6 6" stroke="white" stroke-width="3" fill="none" stroke-linecap="round"/></svg></button>',
        nextArrow: '<button class="sellers-slick-next" aria-label="Next"><svg width="24" height="24" viewBox="0 0 24 24"><path d="M9 6l6 6-6 6" stroke="white" stroke-width="3" fill="none" stroke-linecap="round"/></svg></button>'

      });
    }
  });
});
// -------------------sellers end------------------







// -----------------revolutionizing start-----------------



if ($(Window).width() < 768) {
  $('.revolutionizing__items').slick({
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    responsive: [{
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }, ]
  });
}



$('.revolutionizing__left-arrow').click(function () {
  $(this).parent().parent().find('.slick-slider').slick('slickPrev');
});
$('.revolutionizing__right-arrow').click(function () {
  $(this).parent().parent().find('.slick-slider').slick('slickNext');
});



$('.revolutionizing__items').on('afterChange', function (event, slick, currentSlide) {
  if (currentSlide === 0) {
    $('.revolutionizing__left-arrow').addClass('hidden');
  } else {
    $('.revolutionizing__left-arrow').removeClass('hidden');
  }
  if (currentSlide === slick.slideCount - 1) {
    $('.revolutionizing__right-arrow').addClass('hidden');
  } else {
    $('.revolutionizing__right-arrow').removeClass('hidden');
  }
  // if ($(window).width() > 768) {
  //   if (currentSlide === slick.slideCount - 1) {
  //     $('.revolutionizing__right-arrow').addClass('hidden');
  //   } else {
  //     $('.revolutionizing__right-arrow').removeClass('hidden');
  //   }
  //   // console.log(currentSlide, "-", slick.slideCount - 3);
  // } else {
  //   if (currentSlide === slick.slideCount - 1) {
  //     $('.revolutionizing__right-arrow').addClass('hidden');
  //   } else {
  //     $('.revolutionizing__right-arrow').removeClass('hidden');
  //   }
  // }
});



// -----------------revolutionizing end-----------------





// -----------------review-card start-------------



if ($(Window).width() < 768) {
  $('.review-card__items').slick({
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    responsive: [{
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }, ]
  });
}



$('.review-card__left-arrow').click(function () {
  $(this).parent().parent().find('.slick-slider').slick('slickPrev');
});
$('.review-card__right-arrow').click(function () {
  $(this).parent().parent().find('.slick-slider').slick('slickNext');
});



// $('.review-card__items').on('afterChange', function (event, slick, currentSlide) {
//   if (currentSlide === 0) {
//     $('.review-card__left-arrow').addClass('hidden');
//   } else {
//     $('.review-card__left-arrow').removeClass('hidden');
//   }
//   if (currentSlide === slick.slideCount - 1) {
//     $('.review-card__right-arrow').addClass('hidden');
//   } else {
//     $('.review-card__right-arrow').removeClass('hidden');
//   }
//   // if ($(window).width() > 768) {
//   //   if (currentSlide === slick.slideCount - 1) {
//   //     $('.review-card__right-arrow').addClass('hidden');
//   //   } else {
//   //     $('.review-card__right-arrow').removeClass('hidden');
//   //   }
//   //   // console.log(currentSlide, "-", slick.slideCount - 3);
//   // } else {
//   //   if (currentSlide === slick.slideCount - 1) {
//   //     $('.review-card__right-arrow').addClass('hidden');
//   //   } else {
//   //     $('.review-card__right-arrow').removeClass('hidden');
//   //   }
//   // }
// });



//   $('.review-card__video-play-icon').on('click', function () {
//       var $icon = $(this);
//       var $video = $icon.closest('.review-card__item').find('.review-card__item-img video')[0];
//       // Pause all videos
//       $('.review-card__item-img video').each(function () {
//           this.pause();
//           this.currentTime = 0;
//           $(this).siblings('.review-card__video-play-icon').show();
//           // $(this).hide();
//       });
//       $video.play();
//       $icon.hide();
//       $($video).show();
//   });


//   $('.review-card__item-img video').on('click', function () {
//     var $icon = $(this);
//     // Pause all videos
//     $('.review-card__item-img video').each(function () {
//         this.pause();
//         this.currentTime = 0;
//         $(this).siblings('.review-card__video-play-icon').show();
//     });
//     $video.stop();
// });



$(".review-card__item-img").click(function () {
  var video = $(this).find("video").get(0);
  var icon_image = $(this).find(".review-card__video-play-icon");
  if (video.paused) {
    $("video").each(function () {
      this.pause();
      $(".review-card__video-play-icon").css("display", "block");
    });
    video.play();
    icon_image.css("display", "none");
  } else {
    video.pause();
    icon_image.css("display", "block");
  }
});
$(".review-card__video-play-icon").click(function (e) {
  e.stopPropagation();
  var video = $(this).parent().find("video").get(0);
  var icon_image = $(this);
  if (video.paused) {
    $("video").each(function () {
      this.pause();
      $(".review-card__video-play-icon").css("display", "block");
    });
    video.play();
    icon_image.css("display", "none");
  } else {
    video.pause();
    icon_image.css("display", "block");
  }
});





// -----------------review-card end-------------




// ---------------------footer start--------------------


if ($(Window).width() < 768) {
  $(".footer__center-item h3").click(function () {
    if ($(this).hasClass('active')) {
      $(this).removeClass("active");
      $(this).next(".footer__center-list").slideUp();
    } else {
      $(".footer__center-list").slideUp();
      $(".footer__center-item h3").removeClass("active");
      $(this).addClass("active");
      $(this).next(".footer__center-list").slideDown();
    }
  })
}





// ---------------------footer end--------------------




// -----------------icon-with-text start-----------------



if ($(Window).width() < 768) {
  $('.icon-with-text__items').slick({
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    responsive: [{
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }, ]
  });
}



$('.icon-with-text__left-arrow').click(function () {
  $(this).parent().parent().find('.slick-slider').slick('slickPrev');
});
$('.icon-with-text__right-arrow').click(function () {
  $(this).parent().parent().find('.slick-slider').slick('slickNext');
});



$('.icon-with-text__items').on('afterChange', function (event, slick, currentSlide) {
  if (currentSlide === 0) {
    $('.icon-with-text__left-arrow').addClass('hidden');
  } else {
    $('.icon-with-text__left-arrow').removeClass('hidden');
  }
  if (currentSlide === slick.slideCount - 1) {
    $('.icon-with-text__right-arrow').addClass('hidden');
  } else {
    $('.icon-with-text__right-arrow').removeClass('hidden');
  }
  // if ($(window).width() > 768) {
  //   if (currentSlide === slick.slideCount - 1) {
  //     $('.icon-with-text__right-arrow').addClass('hidden');
  //   } else {
  //     $('.icon-with-text__right-arrow').removeClass('hidden');
  //   }
  //   // console.log(currentSlide, "-", slick.slideCount - 3);
  // } else {
  //   if (currentSlide === slick.slideCount - 1) {
  //     $('.icon-with-text__right-arrow').addClass('hidden');
  //   } else {
  //     $('.icon-with-text__right-arrow').removeClass('hidden');
  //   }
  // }
});



// -----------------icon-with-text end-----------------



// -----------------product-hero start-------------------




$('.product-hero__big-items').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: false,
  asNavFor: '.product-hero__small-items',
  responsive: [{
    breakpoint: 768,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1
    }
  }, ]
});
$('.product-hero__small-items').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  vertical: true,
  asNavFor: '.product-hero__big-items',
  centerMode: false,
  focusOnSelect: true,
  arrows: false,
  responsive: [{
    breakpoint: 768,
    settings: {
      vertical: false,
      slidesToShow: 4,
      slidesToScroll: 1
    }
  }, ]
});



$('.product-hero__small-items-right-arrow').click(function () {
  $(this).parent().parent().find('.slick-slider').slick('slickNext');
});





$(".product-hero__dropdown-title").click(function () {
  if ($(this).hasClass('active')) {
    $(this).removeClass("active");
    $(this).next(".product-hero__dropdown-content").slideUp();
  } else {
    $(".product-hero__dropdown-content").slideUp();
    $(".product-hero__dropdown-title").removeClass("active");
    $(this).addClass("active");
    $(this).next(".product-hero__dropdown-content").slideDown();
  }
})









// -----------------product-hero end-------------------


// --------------benefits start-------------


if ($(Window).width() < 768) {
  $('.benefits__items').slick({
    rows: 2,
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    responsive: [{
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }, ]
  });
}



$('.benefits__left-arrow').click(function () {
  $(this).parent().parent().find('.slick-slider').slick('slickPrev');
});


$('.benefits__right-arrow').click(function () {
  $(this).parent().parent().find('.slick-slider').slick('slickNext');
});


$('.benefits__items').on('afterChange', function (event, slick, currentSlide) {
  if (currentSlide === 0) {
    $('.benefits__left-arrow').addClass('hidden');
  } else {
    $('.benefits__left-arrow').removeClass('hidden');
  }
  if (currentSlide === slick.slideCount - 1) {
    $('.benefits__right-arrow').addClass('hidden');
  } else {
    $('.benefits__right-arrow').removeClass('hidden');
  }
  // if ($(window).width() > 768) {
  //   if (currentSlide === slick.slideCount - 1) {
  //     $('.benefits__right-arrow').addClass('hidden');
  //   } else {
  //     $('.benefits__right-arrow').removeClass('hidden');
  //   }
  //   // console.log(currentSlide, "-", slick.slideCount - 3);
  // } else {
  //   if (currentSlide === slick.slideCount - 1) {
  //     $('.benefits__right-arrow').addClass('hidden');
  //   } else {
  //     $('.benefits__right-arrow').removeClass('hidden');
  //   }
  // }
});




// --------------benefits end-------------


// ---------------ingredients start-----------


if ($(Window).width() < 768) {
  $('.ingredients__items').slick({
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    responsive: [{
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }, ]
  });
}



$('.ingredients__left-arrow').click(function () {
  $(this).parent().parent().find('.slick-slider').slick('slickPrev');
});


$('.ingredients__right-arrow').click(function () {
  $(this).parent().parent().find('.slick-slider').slick('slickNext');
});


$('.ingredients__items').on('afterChange', function (event, slick, currentSlide) {
  if (currentSlide === 0) {
    $('.ingredients__left-arrow').addClass('hidden');
  } else {
    $('.ingredients__left-arrow').removeClass('hidden');
  }
  if (currentSlide === slick.slideCount - 1) {
    $('.ingredients__right-arrow').addClass('hidden');
  } else {
    $('.ingredients__right-arrow').removeClass('hidden');
  }
  // if ($(window).width() > 768) {
  //   if (currentSlide === slick.slideCount - 1) {
  //     $('.ingredients__right-arrow').addClass('hidden');
  //   } else {
  //     $('.ingredients__right-arrow').removeClass('hidden');
  //   }
  //   // console.log(currentSlide, "-", slick.slideCount - 3);
  // } else {
  //   if (currentSlide === slick.slideCount - 1) {
  //     $('.ingredients__right-arrow').addClass('hidden');
  //   } else {
  //     $('.ingredients__right-arrow').removeClass('hidden');
  //   }
  // }
});



// ---------------ingredients end-----------


// -----------------faq start--------------



$(".faq__title").click(function () {
  if ($(this).hasClass('active')) {
    $(this).removeClass("active");
    $(this).next(".faq__item p").slideUp();
  } else {
    $(".faq__item p").slideUp();
    $(".faq__title").removeClass("active");
    $(this).addClass("active");
    $(this).next(".faq__item p").slideDown();
  }
})



// -----------------faq end--------------


// ---------------supplement-details start--------------


$('.ingredients__bottom-btn').on('click', function () {
  $('.supplement-details').toggleClass('active');
  $(this).toggleClass('active');
});


// ---------------supplement-details end--------------


// zoom product js start here 

$('.product-hero__big-item-zoom').magnificPopup({
  delegate: 'a',
  type: 'image',
  tLoading: 'Loading image #%curr%...',
  mainClass: 'mfp-img-mobile',
  gallery: {
    enabled: true,
    navigateByImgClick: true,
    preload: [0, 1]
  }
});

function active_image() {
  $(".product-hero__big-item-zoom a").each(function () {
    var modal_image = $(this).attr("data-index");
    // console.log(modal_image)
    var default_active = $(".product-hero__big-item.slick-active").attr("data-slick-index");
    // console.log(default_active)
    if (modal_image == default_active) {
      $(".product-hero__big-item-zoom a").hide();
      $(this).show();

    }

  })

}

active_image();

$(".product-hero__small-item").on("click", function () {
  active_image();
})













// -------------------collection-shop start----------------


if ($(Window).width() < 768) {
  $(".collection-shop__title").click(function () {
    if ($(this).hasClass('active')) {
      $(this).removeClass("active");
      $(this).next(".collection-shop__content").slideUp();
    } else {
      $(".collection-shop__content").slideUp();
      $(".collection-shop__title").removeClass("active");
      $(this).addClass("active");
      $(this).next(".collection-shop__content").slideDown();
    }
  })
}
// -------------------collection-shop end----------------







// -------------------------collection-filters start--------------------



if ($(Window).width() < 768) {
  $(".collection-filters__filter-title").click(function () {
    if ($(this).hasClass('active')) {
      $(this).removeClass("active");
      $(".collection-filters__filter").slideUp();
      $(".collection-filters__filter").removeClass('active');
    } else {
      $(".collection-filters__filter").slideDown();
      $(this).addClass("active");
      $(".collection-filters__filter").addClass('active');
    }
  })
}





$(".collection-filters__item-title").click(function () {
  console.log($(this))
  if ($(this).hasClass('active')) {
    console.log('hi')
    $(this).removeClass("active");
    $(this).next(".collection-filters__item-content").slideUp();
  } else {
    // $(".collection-filters__item-content").slideUp();
    // $(".collection-filters__item-title").removeClass("active");
    $(this).addClass("active");
    $(this).next(".collection-filters__item-content").slideDown();
  }
})




$(".collection-filters__sort-wrap").click(function () {
  if ($(this).hasClass('active')) {
    $(this).removeClass("active");
    $(".collection-filters__sort").slideUp();
  } else {
    $(".collection-filters__sort").slideDown();
    $(this).addClass("active");
  }
})




$(".collection-filters__select").click(function () {
  if ($(this).hasClass('active')) {
    $(this).removeClass("active");
    $(".collection-filters__top-wrap ul").slideUp();
  } else {
    $(".collection-filters__top-wrap ul").slideDown();
    $(this).addClass("active");
  }
})



$('.collection-filters__left-arrow').click(function () {
  $(this).parent().parent().find('.slick-slider').slick('slickPrev');
});


$('.collection-filters__right-arrow').click(function () {
  $(this).parent().parent().find('.slick-slider').slick('slickNext');
});







$('.collection-filters__product-items').on('afterChange', function (event, slick, currentSlide) {
  if (currentSlide === 0) {
    $('.collection-filters__left-arrow').addClass('hidden');
  } else {
    $('.collection-filters__left-arrow').removeClass('hidden');
  }
  if (currentSlide === slick.slideCount - 1) {
    $('.collection-filters__right-arrow').addClass('hidden');
  } else {
    $('.collection-filters__right-arrow').removeClass('hidden');
  }
  // if ($(window).width() > 768) {
  //   if (currentSlide === slick.slideCount - 1) {
  //     $('.collection-filters__right-arrow').addClass('hidden');
  //   } else {
  //     $('.collection-filters__right-arrow').removeClass('hidden');
  //   }
  //   // console.log(currentSlide, "-", slick.slideCount - 3);
  // } else {
  //   if (currentSlide === slick.slideCount - 1) {
  //     $('.collection-filters__right-arrow').addClass('hidden');
  //   } else {
  //     $('.collection-filters__right-arrow').removeClass('hidden');
  //   }
  // }

});




// collection filter 



function updateCollection() {
  var query = $(".collection-filters__form").serialize();
  console.log(query)
  updateSection(query);
}

function updateSection(query) {
  fetch("?section_id=template-collection&" + query)
    .then(res => res.text())
    .then(data => {
      var col = $(data);
      var card = $(".collection-filters__product", col);
      console.log(card);
      $(".collection-filters__product").replaceWith(card);
    })
  var baseUrl = window.location.pathname;
  var updateUrl = baseUrl + '?' + query;
  window.history.pushState({
    path: updateUrl
  }, '', updateUrl);
}
$(".collection-filters__form input[type=checkbox]").on("change", function (e) {
  updateCollection();
})



// sort by filter 


Shopify.queryParams = {};
let keyValue;
let queries = location.search.substr(1).split('&');
if (location.search.length) {
  for (let i = 0; i < queries.length; i++) {
    keyValue = queries[i].split('=');
    if (keyValue.length > 1) {
      Shopify.queryParams[decodeURIComponent(keyValue[0])] = decodeURIComponent(keyValue[1]);
    }
  }
}
// desktop 

$(".collection-filters__sort-by").on("click", function () {
  var data = $(this).attr("data-src");
  Shopify.queryParams.sort_by = data;
  location.search = new URLSearchParams(Shopify.queryParams).toString()
})

var sort_text = $(".collection-filters__sort-by[selected='selected']").text().trim();
localStorage.setItem("sort__title", sort_text);
var get__value = localStorage.getItem("sort__title");
$(".collection-filters__select-title h4").text(get__value);
//  mobille 

$(".collection-filters__sort-by-mobi").on("click", function () {
  var data = $(this).attr("data-src");
  Shopify.queryParams.sort_by = data;
  location.search = new URLSearchParams(Shopify.queryParams).toString()
})



var sort_textMobi = $(".collection-filters__sort-by-mobi[selected='selected']").text().trim();
localStorage.setItem("sort__title_mobi", sort_textMobi);
var get__value_mobi = localStorage.getItem("sort__title");
$(".collection-filters__sort-title p").text(get__value_mobi);



// selected.addEventListener('change', function (e) {
//   let value = e.currentTarget.value;

// });





// -------------------------collection-filters end--------------------




// ---------------------cart start-----------------

$('.cart__product-add-items').slick({
  dots: true,
  arrows: false,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  adaptiveHeight: true
});



// $(".header__right-cart").on('click',function(){
//   $(".cart").addClass('active');
//   $(".overlay").addClass('active');
// })


// $(".cart__top-cross-img").on('click', function () {

// })

function removeCart_drawer() {
  $(".cart").removeClass('active');
  $(".overlay").removeClass('active');
}


$(".overlay").on('click', function () {
  $(".cart").removeClass('active');
  $(".overlay").removeClass('active');
})

function openCartDrawer() {
  $(".cart").addClass('active');
  $(".overlay").addClass('active');
}

// ---------------------cart end-----------------




// mobile menu js 

$(".header__mobi-left-menu").on("click", function () {
  $(this).addClass("hide");
  $(".header__menu-drawer-close").addClass("active");
  $(".header__menu-drawer").addClass("active");
  $("body").addClass("mobile__menu-open");
})
$(".header__menu-drawer-close").on("click", function () {
  $(this).removeClass("active");
  $(".header__mobi-left-menu").removeClass("hide");
  $(".header__menu-drawer").removeClass("active");
  $("body").removeClass("mobile__menu-open");
})




$('.header__menu-drawer-sub-icon').click(function (e) {
  e.preventDefault();
  $(this).next(".header__menu-drawer-sub-menu").slideToggle(400);

});


$('.header__menu-drawer-sub-child').click(function (e) {

  e.preventDefault();
  $(this).next(".header__menu-drawer-sub-child-wrap").slideToggle(400);

});

// desktop menu js 


$(".header__mega-sub-menu").on("click", function (e) {

  // e.preventDefault();
  $(".header__mega-sub-menu-wrap").css("opacity", 0);
  // alert()

  $(this).next(".header__mega-sub-menu-wrap").css("opacity", 1)
})



var startDate = new Date("Jul 20, 2023 00:00:00").getTime();
var startVal = 1040000;

function counter() {
  var now = new Date().getTime();
  var dif = now - startDate;
  var min = Math.floor((dif % (1000 * 60 * 60)) / (1000 * 60));
  var v = startVal + (min * 2);

  $('.bg-color-with-text__content strong').each(function () {
    $(this).prop('strong', $(this).text()).animate({
      Counter: v
    }, {
      duration: 3000,
      easing: 'swing',
      step: function (now) {
        $(this).text(Math.ceil(now));
      }
    });
  });

}
counter();
var x = setInterval(function () {
  counter();
}, 60000);








document.addEventListener('DOMContentLoaded', function () {
  const currencySelectorButtons = document.querySelectorAll('[data-disclosure-toggle]');
  const currencyOptions = document.querySelectorAll('[data-disclosure-option]');
  currencyOptions.forEach(option => {
    option.addEventListener('click', function (event) {
      event.preventDefault();
      const selectedCurrency = this.getAttribute('data-value');
      const input = document.querySelector('[data-disclosure-input]');

      if (input) {
        input.value = selectedCurrency;
        input.form.submit();
      }
    });
  });

  currencySelectorButtons.forEach(button => {
    button.addEventListener('click', function (event) {
      const targetList = document.querySelector(`#${this.getAttribute('aria-controls')}`);
      const expanded = this.getAttribute('aria-expanded') === 'true';

      this.setAttribute('aria-expanded', !expanded);
      targetList.classList.toggle('disclosure-list--visible');
    });
  });




  // function currencyFormHandle(e){
  //   e.target.form.submit()
  // }
  // document.querySelectorAll(".currency__form").forEach(el=>{
  //   el.addEventListener("change",currencyFormHandle);
  // })
});







$(".menu__no-child").hover(
  function () {
    // Hide .header__mega-menu-product-wrap when hovering over .menu__no-child
    $(".header__mega-menu-product-wrap").hide();
  },
  function () {
    // Show .header__mega-menu-product-wrap when hover ends
    $(".header__mega-menu-product-wrap").show();
  }
);


$(".menu__sub-child").hover(
  function () {

    $(".header__mega-menu-product-wrap").css({
      "background": "linear-gradient(0deg, rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.5)), linear-gradient(0deg, var(--color-primary-5, rgba(255, 102, 194, 0.03)), var(--color-primary-5, rgba(255, 102, 194, 0.03)))",
      "-webkit-backdrop-filter": "blur(20px)",
      "backdrop-filter": "blur(20px)",
      // "opacity":"0.3"


    });
  },
  function () {
    // Remove the background style when hover ends
    $(".header__mega-menu-product-wrap").css({
      "background": "",
      "-webkit-backdrop-filter": "",
      "backdrop-filter": "",
      "opacity": "1"
    });
  }
);













//  currency

// var cart_goal_price = $(".cart__goal-price").attr("shipping-goal-data");

// console.log(cart_goal_price);


// var freeShippingThresholdUSD = parseInt(cart_goal_price);
// var conversionRate = Shopify.currency.rate; 
// var freeShippingThresholdConverted = freeShippingThresholdUSD * conversionRate;

// // $(".cart__goal-price").text(freeShippingThresholdConverted.toFixed(2));

// var cartTotalPrice = Shopify.checkout ? Shopify.checkout.total_price : 0; 
// console.log(cartTotalPrice)
// Shopify provides cart.total_price in cents, so we divide by 100 to get it in the correct format
// cartTotalPrice = cartTotalPrice / 100;
// console.log(cartTotalPrice);



// // Base free shipping threshold in USD (or your store's base currency)
// var freeShippingThresholdUSD = 30.00;

// // Shopify currency object provides conversion rates
// var conversionRate = Shopify.currency.rate; // This gets the rate between base currency and active currency

// // Convert the threshold based on the customer's currency
// var freeShippingThresholdConverted = freeShippingThresholdUSD * conversionRate;

// // Get the current cart total price in the active currency
// var cartTotalPrice = Shopify.checkout ? Shopify.checkout.total_price : 0; // Replace with actual cart total if available

// // Shopify provides cart.total_price in cents, so we divide by 100 to get it in the correct format
// cartTotalPrice = cartTotalPrice / 100;

// // Calculate how much more the customer needs to spend to get free shipping
// var amountNeededForFreeShipping = freeShippingThresholdConverted - cartTotalPrice;

// // Ensure we don't show negative values if the customer already qualifies for free shipping
// if (amountNeededForFreeShipping <= 0) {
//   var message = "Congratulations! You qualify for free shipping.";
// } else {
//   var message = "You need to add " + amountNeededForFreeShipping.toFixed(2) + " " + Shopify.currency.active + " more to get free shipping.";
// }

// // Display the message in an element on the page
// document.getElementById('free-shipping-message').innerText = message;